// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"8bdfbed0","55":"7a16f8b9","80":"e8cb902e","98":"5fb356ea","147":"32f2b0f0","171":"be88e3ab","196":"b12abe65","306":"dc3bf78a","363":"416615f8","374":"8f998552","386":"a90a7161","528":"5e17434d","780":"2b1a23c5"}[chunkId] + ".chunk.js";
};